import React, { createContext, useState, useContext, useEffect } from "react";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

function AuthWrapper({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        console.log("Parsed user from localStorage:", parsedUser); // Debug
        setUser(parsedUser);
      } catch (err) {
        console.error("Failed to parse stored user:", err);
        localStorage.removeItem("user");
      }
    }
  }, []);

  const login = useGoogleLogin({
    scope: "openid email profile",
    onSuccess: async (tokenResponse) => {
      try {
        // Fetch user info from Google
        const res = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        });

        console.log("Google API response:", res.data); // Debug

        if (res.data.email.endsWith("@buyerforesight.com")) {
          const userData = {
            name: res.data.name || "Unknown User",
            email: res.data.email,
            picture: res.data.picture
              ? `${res.data.picture}?t=${Date.now()}` // Cache-busting
              : "https://placehold.co/48x48/png?text=User&font=roboto", // Reliable fallback
          };
          console.log("Setting user data:", userData); // Debug
          setUser(userData);
          localStorage.setItem("user", JSON.stringify(userData));
        } else {
          alert("❌ Only @buyerforesight.com emails are allowed.");
        }
      } catch (err) {
        console.error("Failed to fetch user info:", err);
      }
    },
    onError: () => {
      console.log("Login Failed");
    },
  });

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500">
        <div className="w-full max-w-md p-8 rounded-3xl shadow-2xl bg-white/20 backdrop-blur-lg border border-white/30 flex flex-col items-center gap-6">
          <div className="text-5xl">
            <img
              src="https://www.buyerforesight.com/wp-content/uploads/2025/09/BF-logo-purple.png" // Replace with the actual path to the attached image
              alt="🤖"
              className="w-64 h-32 mx-auto" // Adjust width and height as needed to match the emoji size
            />
          </div>
          <h4 className="text-3xl font-extrabold text-white drop-shadow-lg text-center">
            TVA
          </h4>
          {/* <p className="text-white/90 text-center text-lg">
            Sign in with your <span className="font-semibold">@buyerforesight.com</span> account to continue
          </p> */}

          {/* Custom Google Login Button */}
          <button
            onClick={login}
            className="flex items-center gap-3 px-6 py-3 rounded-full 
                        bg-white/90 hover:bg-white text-gray-800 font-semibold 
                        shadow-xl hover:shadow-2xl transition-all duration-300 
                        backdrop-blur-md"
          >
            {/* Google "G" Logo */}
            <img
              src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
              alt="Google logo"
              className="w-5 h-5"
            />
            <span>Sign in with Google</span>
          </button>

          <p className="text-xs text-white/70 text-center">
            © {new Date().getFullYear()} BuyerForesight
          </p>
        </div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
}

export default function AuthProvider({ children }) {
  return (
    <GoogleOAuthProvider clientId="254591168563-mer8l94giktd0a05p3o8g6364cbpkn6a.apps.googleusercontent.com">
      <AuthWrapper>{children}</AuthWrapper>
    </GoogleOAuthProvider>
  );
}